import styles from './VendorNotFoundBanner.module.css';

interface VendorNotFoundBannerProps {
  /** Navigate to the list tab in-app (the banner link intercepts /list). */
  onBrowseList: () => void;
  /** Hide the banner. */
  onDismiss: () => void;
}

/**
 * Small dismissible toast shown over the map when a vendor deep link
 * (`/listing/<uid>`) resolves to nothing — an unknown uid, or a vendor
 * dropped from this week's dataset (`here=no` rotation). Rendered by
 * AppShell inside the map container. Not a live region itself (it holds
 * interactive children); AppShell announces the notice via its SR-only
 * status region instead.
 */
export function VendorNotFoundBanner({ onBrowseList, onDismiss }: VendorNotFoundBannerProps) {
  return (
    <div className={styles.root}>
      <p className={styles.message}>
        We couldn’t find that vendor — they may not be here this week.{' '}
        <a
          href="/list"
          className={styles.link}
          onClick={(e) => {
            e.preventDefault();
            onBrowseList();
          }}
        >
          Browse the list
        </a>{' '}
        to see who is.
      </p>
      <button
        type="button"
        className={styles.dismissBtn}
        onClick={onDismiss}
        aria-label="Dismiss notice"
      >
        <svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true">
          <path
            d="M3 3 L11 11 M11 3 L3 11"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
          />
        </svg>
      </button>
    </div>
  );
}
